const UrlEnums = {
  MAIN: '/',
  PROFILE: '/profile',
  ADMIN: '/admin',
  LOGIN: '/login',
  SIGN_UP: '/signUp',
  LOGOUT: '/logout',
  PASSWORD_FORGET: '/forgetPassword',
  PASSWORD_RESET: '/resetPassword/:resetToken',
  VERIFY: '/verify/:verificationToken',
  SHOWCASE: '/showcase',
  NOT_FOUND: '/notFound',
  PRIVACY_POLICY: '/privacyPolicy',
  TERMS: '/terms',
  HELP: '/help',
  IMPRINT: '/imprint',

  // Companies
  COMPANIES: '/companies',
  COMPANY_CREATE: '/companies/new',
  COMPANY_DETAIL: '/companies/:companyId',
  COMPANY_EDIT: '/companies/:companyId/edit',
  COMPANY_SETTINGS: '/companies/:companyId/settings',

  // Customers
  CUSTOMERS: '/companies/:companyId/customers',
  CUSTOMER_CREATE: '/companies/:companyId/customers/new',
  CUSTOMER_EDIT: '/companies/:companyId/customers/:customerId/edit',

  // Invoices
  INVOICES: '/companies/:companyId/invoices',
  INVOICE_CREATE: '/companies/:companyId/invoices/new',
  INVOICE_EDIT: '/companies/:companyId/invoices/:invoiceId/edit',
};
export default UrlEnums;
